// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 29) return "static/js/0415ace15acb115ce12d.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"e6f3d58c007bdab5c74b","148":"41962bafa5fe10918e89","149":"a85ad761590eb2d289a4"}[chunkId] + ".chunk.js";
};